module.exports = __webpack_public_path__ + "static/img/an_1.1f02ab9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/an_1.png
// module id = 823
// module chunks = 1